// 统一的"直接启动游戏"入口
// 用于常玩、热门推荐、分类、排行、搜索和游戏记录等场景

import { loadFullPortalData } from '../store/data'
import { trackBoxLaunch } from './tracking'
import { isCmccEnvironment, cmccOpenWebView } from './bridge'

/**
 * 根据完整 game 对象直接启动游戏
 * @param {Object} store - vuex store
 * @param {Object} game - 完整游戏对象（含 id/cpGameUrl/name）
 * @param {String} source - 埋点来源（frequent / recommend / category / detail 等）
 * @param {String} page - 埋点页面（home / game_detail）
 */
export function launchGameByObject(store, game, source, page) {
  if (!game || !game.id) return
  try { trackBoxLaunch(store, game.id, source || '', page || 'home') } catch (e) {}
  var url = game.cpGameUrl || ''
  if (!url) return
  if (isCmccEnvironment()) {
    cmccOpenWebView(url, { title: game.name || '' })
      .catch(function() { window.location.href = url })
    return
  }
  window.location.href = url
}

/**
 * 根据 gameId 查询完整游戏数据后启动
 * 用于 Home 里精简的 game 对象（只有 gameId/name/icon）场景
 * @param {Object} store - vuex store
 * @param {String|Number} gameId - 游戏 ID
 * @param {String} source - 埋点来源
 * @param {String} page - 埋点页面
 */
export function launchGameById(store, gameId, source, page) {
  if (!gameId) return Promise.resolve()
  var userId = store && store.state.userInfo && store.state.userInfo.userId
  return loadFullPortalData(userId).then(function(data) {
    var key = String(gameId)
    var full = (data && data.gamesById && data.gamesById[key])
      || ((data && data.games) || []).find(function(g) { return String(g.id) === key })
    if (!full) return
    launchGameByObject(store, full, source, page)
  }).catch(function() {})
}
